<template>
  <a-modal
    :title="title"
    centered
    :width="500"
    :mask-closable="false"
    :visible="showCreateEmailForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <template v-if="model.field == 'email'">
            <!-- 快手：邮箱从【邮箱配置】(media=快手) 下拉选择，避免手填与配置不一致导致绑定到无登录态的账号 -->
            <a-form-model-item v-if="model.emails && model.emails.length > 0" label="邮箱" prop="email" help="邮箱列表来源于【邮箱配置】（媒体=快手），已配置 Cookie 才可用于登录快手后台">
              <a-select
                v-model="model.email"
                show-search
                allow-clear
                option-filter-prop="children"
                placeholder="请选择快手邮箱"
                style="width:300px"
              >
                <a-select-option v-for="item in model.emails" :key="item.name" :value="item.name">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item v-else label="邮箱" prop="email" help="请参照【18096505205@163.com】邮箱格式填写">
              <a-input v-model="model.email" style="width:300px" />
            </a-form-model-item>
          </template>

        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'CreateEmail';
</style>

<script>
import CreateEmail from './CreateEmail'
export default CreateEmail
</script>
